import React from "react";
import { useTranslation } from "react-i18next";
import GreenRectangle from "../../../../assets/profile/icons/rectangle.svg";

interface StatisticsElement {
  title: string;
  total: string | number;
  percents: string;
  icon: string;
}
export const AffiliatesStatisticsBlock = ({
  element,
}: {
  element: StatisticsElement;
}) => {
  const { i18n, t } = useTranslation(["profile"]);

  return (
    <div
      className="affiliates-statistics-block"
      style={{
        direction: i18n.dir(),
      }}
    >
      <div>
        <div className="affiliates-statistics-block-title">
          {t(element.title)}
        </div>
        <div className="affiliates-statistics-block-total-count">
          {element.total}
        </div>
        <div className="affiliates-statistics-block-percent-container">
          <div className="affiliates-statistics-block-percents">
            {t(element.percents)}
          </div>
          <img src={GreenRectangle} />
        </div>
      </div>
      <div className="affiliates-statistics-block-icon-block">
        <img src={element.icon} />
      </div>
    </div>
  );
};
